import { BiBookOpen } from "react-icons/bi"
import { SiAdguard } from "react-icons/si"
import { BsTruck } from "react-icons/bs"
import { FaMask } from "react-icons/fa"
import { AiOutlineFlag } from "react-icons/ai"

export const FacilitiesItemsTwo = [

    {
        icon: <BiBookOpen />,
        title: "Felicitare cadou",
        content: "Primești o felicitare cadou la fiecare comandă plasată!"
    },
    {
        icon: <SiAdguard />,
        title: "Calitate garantata",
        content: "Flori de calitate superioara, de la producatori certificati international"
    },

    {
        icon: <FaMask />,
        title: "100% discreție",
        content: "Poți comanda anonim, iar noi vom păstra confidențialitatea."
    },
    {
        icon: <AiOutlineFlag />,
        title: "Livrare internațională",
        content: "Livrăm oriunde în lume, în doar 24 de ore."
    },
    {
        icon: <BsTruck />,
        title: "Livrare în 2 - 4 ore",
        content: "Livrare în 2-4 ore de la plasarea comenzii. Oriunde în țară!"
    },
    {
        icon: <BiBookOpen />,
        title: "Felicitare cadou",
        content: "Primești o felicitare cadou la fiecare comandă plasată!"
    }
]